import { Company } from './Company'
import { Industry } from './Industry'
import { Macroeconomic } from './Macroeconomic'
import classes from './index.module.scss'

export const Header = ({ data, detailKey, isCompany, isIndustry }) => {
  return (
    <div className={classes.container} style={{ borderBottomColor: '#e5e5e8' }}>
      {isCompany ? (
        <Company />
      ) : isIndustry ? (
        <Industry data={data} detailKey={detailKey} />
      ) : (
        <Macroeconomic />
      )}
    </div>
  )
}
